// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Menu Catalog Component Styles */
.menu-catalog {
  padding: 40px 0;
  background-color: #ffffff;
  width: 100%;
  overflow-x: hidden;
}

.menu-catalog__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
  width: 100%;
  position: relative;
}

/* Header */
.menu-catalog__header {
  text-align: center;
  margin-bottom: 40px;
}

.menu-catalog__title {
  font-size: 3rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.menu-catalog__description {
  font-size: 1.2rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Category Filters */
.menu-catalog__filters {
  display: flex;
  justify-content: center;
  gap: 0;
  margin-bottom: 40px;
  border-bottom: 1px solid #ddd;
  overflow-x: auto;
  padding-bottom: 0;
}

.menu-catalog__filter {
  padding: 12px 24px;
  border: none;
  background: transparent;
  color: #666;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.menu-catalog__filter:hover {
  color: #333;
  background: #f8f9fa;
}

.menu-catalog__filter.active {
  color: #fff;
  background: #000;
  border-bottom-color: #000;
}

/* Main Content Layout */
.menu-catalog__content {
  display: grid;
  grid-template-columns: 250px 1fr;
  gap: 30px;
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

/* Sidebar */
.menu-catalog__sidebar {
  background: #fff;
  padding: 0;
  height: fit-content;
  position: sticky;
  top: 20px;
}

.menu-catalog__sidebar-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #333;
}

.menu-catalog__sidebar-categories {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.menu-catalog__sidebar-item {
  padding: 12px 0;
  color: #666;
  cursor: pointer;
  transition: color 0.3s ease;
  font-weight: 400;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.menu-catalog__sidebar-item:hover {
  color: #4A90E2;
}

.menu-catalog__sidebar-item.active {
  color: #4A90E2;
  font-weight: 600;
}

/* Products Section */
.menu-catalog__products {
  flex: 1;
}

/* Toolbar */
.menu-catalog__toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
  flex-wrap: wrap;
  gap: 15px;
}

.menu-catalog__toolbar-left {
  display: flex;
  align-items: center;
}

.menu-catalog__view-toggle {
  display: flex;
  gap: 8px;
}

.menu-catalog__view-btn {
  padding: 8px;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
  font-size: 16px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-catalog__view-btn:hover {
  background: #E6F3FF;
  border-color: #4A90E2;
}

.menu-catalog__view-btn.active {
  background: #4A90E2;
  color: white;
  border-color: #4A90E2;
}

.menu-catalog__toolbar-center {
  font-weight: 500;
  color: #666;
  font-size: 14px;
}

/* Products Grid */
.menu-catalog__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(300px, 100%), 1fr));
  gap: 25px;
  width: 100%;
  box-sizing: border-box;
}

.menu-catalog__grid.list-view {
  grid-template-columns: 1fr;
  gap: 20px;
}

.menu-catalog__product-card {
  background: white;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
}

.menu-catalog__product-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
}

.menu-catalog__product-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.menu-catalog__product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.menu-catalog__product-card:hover .menu-catalog__product-image img {
  transform: scale(1.05);
}

.menu-catalog__product-placeholder {
  width: 100%;
  height: 100%;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-weight: 600;
  font-size: 2rem;
}

.menu-catalog__product-info {
  padding: 20px;
}

.menu-catalog__product-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
  line-height: 1.3;
}

.menu-catalog__product-title a {
  color: inherit;
  text-decoration: none;
  transition: color 0.3s ease;
}

.menu-catalog__product-title a:hover {
  color: #007bff;
}

.menu-catalog__product-description {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.4;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.menu-catalog__product-price {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.menu-catalog__price-current {
  font-size: 1.2rem;
  font-weight: 700;
  color: #e74c3c;
}

.menu-catalog__price-original {
  font-size: 0.9rem;
  color: #999;
  text-decoration: line-through;
}

.menu-catalog__add-to-cart {
  width: 100%;
  padding: 12px;
  background: #000;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.9rem;
}

.menu-catalog__add-to-cart:hover {
  background: #333;
}

.menu-catalog__product-tags {
  padding: 0 20px 20px;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.menu-catalog__tag {
  padding: 4px 8px;
  background: #f8f9fa;
  color: #666;
  font-size: 0.75rem;
  border-radius: 12px;
  text-transform: lowercase;
}

.menu-catalog__no-products {
  text-align: center;
  padding: 60px 20px;
  color: #666;
  font-size: 1.1rem;
  grid-column: 1 / -1;
}

.menu-catalog__loading {
  text-align: center;
  padding: 60px 20px;
  color: #4A90E2;
  font-size: 1.1rem;
  grid-column: 1 / -1;
}

/* List View Styles */
.menu-catalog__grid.list-view .menu-catalog__product-card {
  display: grid;
  grid-template-columns: 200px 1fr auto;
  gap: 20px;
  align-items: center;
}

.menu-catalog__grid.list-view .menu-catalog__product-image {
  height: 120px;
  width: 200px;
}

.menu-catalog__grid.list-view .menu-catalog__product-info {
  padding: 20px 0;
}

.menu-catalog__grid.list-view .menu-catalog__add-to-cart {
  width: 150px;
  margin-right: 20px;
}

.menu-catalog__grid.list-view .menu-catalog__product-tags {
  display: none;
}

/* Responsive Design */
@media (max-width: 1400px) {
  .menu-catalog__grid {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }
}

@media (max-width: 1200px) {
  .menu-catalog__container {
    padding: 0 15px;
  }
  
  .menu-catalog__content {
    grid-template-columns: 220px 1fr;
    gap: 25px;
  }
  
  .menu-catalog__grid {
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  }
  
  .menu-catalog__sidebar {
    width: 220px;
  }
}

@media (max-width: 1024px) {
  .menu-catalog__content {
    grid-template-columns: 200px 1fr;
    gap: 20px;
  }
  
  .menu-catalog__grid {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  }
  
  .menu-catalog__sidebar {
    width: 200px;
  }
  
  .menu-catalog__sidebar-item {
    font-size: 13px;
    padding: 10px 0;
  }
}

@media (max-width: 768px) {
  .menu-catalog {
    padding: 20px 0;
  }

  .menu-catalog__container {
    padding: 0;
    margin: 0;
    width: 100%;
    max-width: 100%;
  }

  .menu-catalog__content {
    grid-template-columns: 1fr;
    gap: 20px;
    width: 100%;
    padding: 0 15px;
  }

  .menu-catalog__sidebar {
    position: static;
    background: #f8f9fa;
    padding: 15px;
    border-radius: 15px;
    width: 100%;
    order: -1;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin: 0;
  }

  .menu-catalog__sidebar-title {
    font-size: 18px;
    margin-bottom: 15px;
    text-align: center;
    color: #333;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .menu-catalog__sidebar-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
    padding: 0;
  }

  .menu-catalog__sidebar-item {
    padding: 10px 18px;
    border: 2px solid #e0e0e0;
    border-radius: 25px;
    background: white;
    color: #555;
    font-size: 13px;
    font-weight: 600;
    transition: all 0.3s ease;
    cursor: pointer;
    white-space: nowrap;
  }
  
  .menu-catalog__sidebar-item:hover {
    background: #4A90E2;
    color: white;
    border-color: #4A90E2;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
  }
  
  .menu-catalog__sidebar-item.active {
    background: #4A90E2;
    color: white;
    border-color: #4A90E2;
    box-shadow: 0 4px 15px rgba(74, 144, 226, 0.4);
  }

  .menu-catalog__grid {
    grid-template-columns: 1fr;
    gap: 20px;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .menu-catalog__product-card {
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    width: 100%;
    margin: 0;
    max-width: none;
  }

  .menu-catalog__product-image {
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    width: 100%;
    overflow: hidden;
  }

  .menu-catalog__product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0;
    transition: transform 0.3s ease;
  }

  .menu-catalog__product-placeholder {
    width: 100%;
    height: 100%;
    background: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-weight: 600;
    font-size: 1.5rem;
  }

  .menu-catalog__toolbar {
    flex-direction: column;
    gap: 15px;
    align-items: center;
    background: #f8f9fa;
    padding: 15px;
    border-radius: 15px;
    border: none;
    margin: 20px 0;
    width: 100%;
    max-width: none;
  }
  
  .menu-catalog__toolbar-left {
    justify-content: center;
    order: 2;
  }

  .menu-catalog__toolbar-center {
    text-align: center;
    order: 1;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  .menu-catalog__view-toggle {
    justify-content: center;
    gap: 12px;
  }

  .menu-catalog__view-btn {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    font-size: 18px;
    border: 2px solid #ddd;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .menu-catalog__view-btn:hover {
    background: #E6F3FF;
    border-color: #4A90E2;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.2);
  }

  .menu-catalog__view-btn.active {
    background: #4A90E2;
    color: white;
    border-color: #4A90E2;
    box-shadow: 0 4px 15px rgba(74, 144, 226, 0.4);
  }

  .menu-catalog__title {
    font-size: 2rem;
    text-align: center;
    margin-bottom: 15px;
    width: 100%;
    padding: 0 15px;
  }
  
  .menu-catalog__description {
    text-align: center;
    font-size: 16px;
    color: #666;
    margin-bottom: 25px;
    width: 100%;
    max-width: 100%;
    padding: 0 15px;
  }

  .menu-catalog__header {
    text-align: center;
    margin-bottom: 30px;
    width: 100%;
    padding: 0;
  }

  /* List view adjustments for mobile */
  .menu-catalog__grid.list-view {
    gap: 15px;
  }

  .menu-catalog__grid.list-view .menu-catalog__product-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 15px;
    gap: 15px;
  }

  .menu-catalog__grid.list-view .menu-catalog__product-image {
    height: 100px;
    width: 100px;
    min-width: 100px;
    border-radius: 10px;
    overflow: hidden;
  }

  .menu-catalog__grid.list-view .menu-catalog__product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .menu-catalog__grid.list-view .menu-catalog__product-info {
    flex: 1;
    padding: 0;
  }

  .menu-catalog__grid.list-view .menu-catalog__product-title {
    font-size: 16px;
    margin-bottom: 5px;
  }

  .menu-catalog__grid.list-view .menu-catalog__product-description {
    font-size: 14px;
    margin-bottom: 10px;
    -webkit-line-clamp: 1;
    line-clamp: 1;
  }

  .menu-catalog__grid.list-view .menu-catalog__add-to-cart {
    width: auto;
    padding: 8px 16px;
    font-size: 12px;
    margin: 0;
    align-self: flex-start;
  }

  .menu-catalog__grid.list-view .menu-catalog__product-tags {
    display: none;
  }
}

@media (max-width: 480px) {
  .menu-catalog__container {
    padding: 0 5px;
  }
  
  .menu-catalog__title {
    font-size: 1.5rem;
  }
  
  .menu-catalog__sidebar {
    padding: 10px;
  }
  
  .menu-catalog__sidebar-item {
    padding: 8px 16px;
    font-size: 12px;
  }
  
  .menu-catalog__view-btn {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
  
  .menu-catalog__product-card {
    padding: 15px;
  }
  
  .menu-catalog__product-image {
    height: 180px;
  }
  
  .menu-catalog__product-title a {
    font-size: 16px;
  }
  
  .menu-catalog__add-to-cart {
    padding: 10px 15px;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MenuCatalog.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,MAAM;EACN,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,OAAO;AACT;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sEAAsE;EACtE,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,wCAAwC;IACxC,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,8CAA8C;EAChD;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,WAAW;IACX,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;IAC1C,WAAW;IACX,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,wCAAwC;EAC1C;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,8CAA8C;EAChD;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,UAAU;EACZ;;EAEA,qCAAqC;EACrC;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,OAAO;IACP,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["/* Menu Catalog Component Styles */\n.menu-catalog {\n  padding: 40px 0;\n  background-color: #ffffff;\n  width: 100%;\n  overflow-x: hidden;\n}\n\n.menu-catalog__container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  box-sizing: border-box;\n  width: 100%;\n  position: relative;\n}\n\n/* Header */\n.menu-catalog__header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.menu-catalog__title {\n  font-size: 3rem;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 16px;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n}\n\n.menu-catalog__description {\n  font-size: 1.2rem;\n  color: #666;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n/* Category Filters */\n.menu-catalog__filters {\n  display: flex;\n  justify-content: center;\n  gap: 0;\n  margin-bottom: 40px;\n  border-bottom: 1px solid #ddd;\n  overflow-x: auto;\n  padding-bottom: 0;\n}\n\n.menu-catalog__filter {\n  padding: 12px 24px;\n  border: none;\n  background: transparent;\n  color: #666;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-bottom: 2px solid transparent;\n  white-space: nowrap;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.menu-catalog__filter:hover {\n  color: #333;\n  background: #f8f9fa;\n}\n\n.menu-catalog__filter.active {\n  color: #fff;\n  background: #000;\n  border-bottom-color: #000;\n}\n\n/* Main Content Layout */\n.menu-catalog__content {\n  display: grid;\n  grid-template-columns: 250px 1fr;\n  gap: 30px;\n  margin-top: 20px;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n/* Sidebar */\n.menu-catalog__sidebar {\n  background: #fff;\n  padding: 0;\n  height: fit-content;\n  position: sticky;\n  top: 20px;\n}\n\n.menu-catalog__sidebar-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 20px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #333;\n}\n\n.menu-catalog__sidebar-categories {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.menu-catalog__sidebar-item {\n  padding: 12px 0;\n  color: #666;\n  cursor: pointer;\n  transition: color 0.3s ease;\n  font-weight: 400;\n  border-bottom: 1px solid #f0f0f0;\n  font-size: 14px;\n}\n\n.menu-catalog__sidebar-item:hover {\n  color: #4A90E2;\n}\n\n.menu-catalog__sidebar-item.active {\n  color: #4A90E2;\n  font-weight: 600;\n}\n\n/* Products Section */\n.menu-catalog__products {\n  flex: 1;\n}\n\n/* Toolbar */\n.menu-catalog__toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #eee;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.menu-catalog__toolbar-left {\n  display: flex;\n  align-items: center;\n}\n\n.menu-catalog__view-toggle {\n  display: flex;\n  gap: 8px;\n}\n\n.menu-catalog__view-btn {\n  padding: 8px;\n  border: 1px solid #ddd;\n  background: white;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n  font-size: 16px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.menu-catalog__view-btn:hover {\n  background: #E6F3FF;\n  border-color: #4A90E2;\n}\n\n.menu-catalog__view-btn.active {\n  background: #4A90E2;\n  color: white;\n  border-color: #4A90E2;\n}\n\n.menu-catalog__toolbar-center {\n  font-weight: 500;\n  color: #666;\n  font-size: 14px;\n}\n\n/* Products Grid */\n.menu-catalog__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(300px, 100%), 1fr));\n  gap: 25px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.menu-catalog__grid.list-view {\n  grid-template-columns: 1fr;\n  gap: 20px;\n}\n\n.menu-catalog__product-card {\n  background: white;\n  border: 1px solid #eee;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  cursor: pointer;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.menu-catalog__product-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0,0,0,0.1);\n}\n\n.menu-catalog__product-image {\n  position: relative;\n  height: 200px;\n  overflow: hidden;\n}\n\n.menu-catalog__product-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.menu-catalog__product-card:hover .menu-catalog__product-image img {\n  transform: scale(1.05);\n}\n\n.menu-catalog__product-placeholder {\n  width: 100%;\n  height: 100%;\n  background: #f8f9fa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #999;\n  font-weight: 600;\n  font-size: 2rem;\n}\n\n.menu-catalog__product-info {\n  padding: 20px;\n}\n\n.menu-catalog__product-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #333;\n  line-height: 1.3;\n}\n\n.menu-catalog__product-title a {\n  color: inherit;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.menu-catalog__product-title a:hover {\n  color: #007bff;\n}\n\n.menu-catalog__product-description {\n  color: #666;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  margin-bottom: 12px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.menu-catalog__product-price {\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.menu-catalog__price-current {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #e74c3c;\n}\n\n.menu-catalog__price-original {\n  font-size: 0.9rem;\n  color: #999;\n  text-decoration: line-through;\n}\n\n.menu-catalog__add-to-cart {\n  width: 100%;\n  padding: 12px;\n  background: #000;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 0.9rem;\n}\n\n.menu-catalog__add-to-cart:hover {\n  background: #333;\n}\n\n.menu-catalog__product-tags {\n  padding: 0 20px 20px;\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.menu-catalog__tag {\n  padding: 4px 8px;\n  background: #f8f9fa;\n  color: #666;\n  font-size: 0.75rem;\n  border-radius: 12px;\n  text-transform: lowercase;\n}\n\n.menu-catalog__no-products {\n  text-align: center;\n  padding: 60px 20px;\n  color: #666;\n  font-size: 1.1rem;\n  grid-column: 1 / -1;\n}\n\n.menu-catalog__loading {\n  text-align: center;\n  padding: 60px 20px;\n  color: #4A90E2;\n  font-size: 1.1rem;\n  grid-column: 1 / -1;\n}\n\n/* List View Styles */\n.menu-catalog__grid.list-view .menu-catalog__product-card {\n  display: grid;\n  grid-template-columns: 200px 1fr auto;\n  gap: 20px;\n  align-items: center;\n}\n\n.menu-catalog__grid.list-view .menu-catalog__product-image {\n  height: 120px;\n  width: 200px;\n}\n\n.menu-catalog__grid.list-view .menu-catalog__product-info {\n  padding: 20px 0;\n}\n\n.menu-catalog__grid.list-view .menu-catalog__add-to-cart {\n  width: 150px;\n  margin-right: 20px;\n}\n\n.menu-catalog__grid.list-view .menu-catalog__product-tags {\n  display: none;\n}\n\n/* Responsive Design */\n@media (max-width: 1400px) {\n  .menu-catalog__grid {\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  }\n}\n\n@media (max-width: 1200px) {\n  .menu-catalog__container {\n    padding: 0 15px;\n  }\n  \n  .menu-catalog__content {\n    grid-template-columns: 220px 1fr;\n    gap: 25px;\n  }\n  \n  .menu-catalog__grid {\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  }\n  \n  .menu-catalog__sidebar {\n    width: 220px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .menu-catalog__content {\n    grid-template-columns: 200px 1fr;\n    gap: 20px;\n  }\n  \n  .menu-catalog__grid {\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  }\n  \n  .menu-catalog__sidebar {\n    width: 200px;\n  }\n  \n  .menu-catalog__sidebar-item {\n    font-size: 13px;\n    padding: 10px 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .menu-catalog {\n    padding: 20px 0;\n  }\n\n  .menu-catalog__container {\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .menu-catalog__content {\n    grid-template-columns: 1fr;\n    gap: 20px;\n    width: 100%;\n    padding: 0 15px;\n  }\n\n  .menu-catalog__sidebar {\n    position: static;\n    background: #f8f9fa;\n    padding: 15px;\n    border-radius: 15px;\n    width: 100%;\n    order: -1;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    margin: 0;\n  }\n\n  .menu-catalog__sidebar-title {\n    font-size: 18px;\n    margin-bottom: 15px;\n    text-align: center;\n    color: #333;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n  }\n\n  .menu-catalog__sidebar-categories {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    justify-content: center;\n    padding: 0;\n  }\n\n  .menu-catalog__sidebar-item {\n    padding: 10px 18px;\n    border: 2px solid #e0e0e0;\n    border-radius: 25px;\n    background: white;\n    color: #555;\n    font-size: 13px;\n    font-weight: 600;\n    transition: all 0.3s ease;\n    cursor: pointer;\n    white-space: nowrap;\n  }\n  \n  .menu-catalog__sidebar-item:hover {\n    background: #4A90E2;\n    color: white;\n    border-color: #4A90E2;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);\n  }\n  \n  .menu-catalog__sidebar-item.active {\n    background: #4A90E2;\n    color: white;\n    border-color: #4A90E2;\n    box-shadow: 0 4px 15px rgba(74, 144, 226, 0.4);\n  }\n\n  .menu-catalog__grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n  }\n\n  .menu-catalog__product-card {\n    border-radius: 15px;\n    overflow: hidden;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    margin: 0;\n    max-width: none;\n  }\n\n  .menu-catalog__product-image {\n    height: 220px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f8f9fa;\n    width: 100%;\n    overflow: hidden;\n  }\n\n  .menu-catalog__product-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 0;\n    transition: transform 0.3s ease;\n  }\n\n  .menu-catalog__product-placeholder {\n    width: 100%;\n    height: 100%;\n    background: #f0f0f0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #999;\n    font-weight: 600;\n    font-size: 1.5rem;\n  }\n\n  .menu-catalog__toolbar {\n    flex-direction: column;\n    gap: 15px;\n    align-items: center;\n    background: #f8f9fa;\n    padding: 15px;\n    border-radius: 15px;\n    border: none;\n    margin: 20px 0;\n    width: 100%;\n    max-width: none;\n  }\n  \n  .menu-catalog__toolbar-left {\n    justify-content: center;\n    order: 2;\n  }\n\n  .menu-catalog__toolbar-center {\n    text-align: center;\n    order: 1;\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n  }\n\n  .menu-catalog__view-toggle {\n    justify-content: center;\n    gap: 12px;\n  }\n\n  .menu-catalog__view-btn {\n    width: 44px;\n    height: 44px;\n    border-radius: 12px;\n    font-size: 18px;\n    border: 2px solid #ddd;\n    background: white;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .menu-catalog__view-btn:hover {\n    background: #E6F3FF;\n    border-color: #4A90E2;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.2);\n  }\n\n  .menu-catalog__view-btn.active {\n    background: #4A90E2;\n    color: white;\n    border-color: #4A90E2;\n    box-shadow: 0 4px 15px rgba(74, 144, 226, 0.4);\n  }\n\n  .menu-catalog__title {\n    font-size: 2rem;\n    text-align: center;\n    margin-bottom: 15px;\n    width: 100%;\n    padding: 0 15px;\n  }\n  \n  .menu-catalog__description {\n    text-align: center;\n    font-size: 16px;\n    color: #666;\n    margin-bottom: 25px;\n    width: 100%;\n    max-width: 100%;\n    padding: 0 15px;\n  }\n\n  .menu-catalog__header {\n    text-align: center;\n    margin-bottom: 30px;\n    width: 100%;\n    padding: 0;\n  }\n\n  /* List view adjustments for mobile */\n  .menu-catalog__grid.list-view {\n    gap: 15px;\n  }\n\n  .menu-catalog__grid.list-view .menu-catalog__product-card {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 15px;\n    gap: 15px;\n  }\n\n  .menu-catalog__grid.list-view .menu-catalog__product-image {\n    height: 100px;\n    width: 100px;\n    min-width: 100px;\n    border-radius: 10px;\n    overflow: hidden;\n  }\n\n  .menu-catalog__grid.list-view .menu-catalog__product-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .menu-catalog__grid.list-view .menu-catalog__product-info {\n    flex: 1;\n    padding: 0;\n  }\n\n  .menu-catalog__grid.list-view .menu-catalog__product-title {\n    font-size: 16px;\n    margin-bottom: 5px;\n  }\n\n  .menu-catalog__grid.list-view .menu-catalog__product-description {\n    font-size: 14px;\n    margin-bottom: 10px;\n    -webkit-line-clamp: 1;\n    line-clamp: 1;\n  }\n\n  .menu-catalog__grid.list-view .menu-catalog__add-to-cart {\n    width: auto;\n    padding: 8px 16px;\n    font-size: 12px;\n    margin: 0;\n    align-self: flex-start;\n  }\n\n  .menu-catalog__grid.list-view .menu-catalog__product-tags {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .menu-catalog__container {\n    padding: 0 5px;\n  }\n  \n  .menu-catalog__title {\n    font-size: 1.5rem;\n  }\n  \n  .menu-catalog__sidebar {\n    padding: 10px;\n  }\n  \n  .menu-catalog__sidebar-item {\n    padding: 8px 16px;\n    font-size: 12px;\n  }\n  \n  .menu-catalog__view-btn {\n    width: 32px;\n    height: 32px;\n    font-size: 14px;\n  }\n  \n  .menu-catalog__product-card {\n    padding: 15px;\n  }\n  \n  .menu-catalog__product-image {\n    height: 180px;\n  }\n  \n  .menu-catalog__product-title a {\n    font-size: 16px;\n  }\n  \n  .menu-catalog__add-to-cart {\n    padding: 10px 15px;\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
